import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../dashboard/dashboard.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Observer } from "mobx-react";
import { useStores } from "../../store";
import { MdOutlineUpcoming } from "react-icons/md";
import { toJS } from "mobx";
import { interviewsList } from "../../helpers/constantVariables";
import careerImg1 from "../../assests/careerImg1.png";
import careerImg2 from "../../assests/careerImg2.png";
import careerImg3 from "../../assests/careerImg3.png";
import careerImg4 from "../../assests/careerImg4.png";

export default function CarrerSlider() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const { UserStore, InterviewStore, PopupStore, CommonStore } = useStores();
  const [interviewListWithModels, setInterviewListWithModels] =
    useState(interviewsList);

  const freeInterviews = [
    {
      img: <MdOutlineUpcoming />,
      title: "English Practice Bot",
      id: 6, // interview id
      sort: 8,
      description:
        "English practice bot is a bot that helps you to practice your English speaking skills. It will ask you questions and you have to answer them. It will also give you feedback on your answers.",
      active: true,
    },
  ];
  const [interviews, setinterviews] = useState(freeInterviews);

  function showReferAndEarn(onClick) {
    PopupStore.setReferAndEarn(true);
    if (onClick) {
      onClick();
    }
  }
  //   const handleScrollDown = () => {
  //     try {
  //       const customScrollHeight = 500; // Set your custom height here

  //       console.log('Before scrolling:', window.scrollY);
  //       window.scrollTo({
  //         top: window.scrollY + customScrollHeight,
  //         behavior: 'smooth',
  //       });
  //       console.log('After scrolling:', window.scrollY);
  //     } catch (error) {
  //       console.error('Error during scrolling:', error);
  //     }
  //   };

  function settingPopup() {
    PopupStore.setCreateInterview(false);
    PopupStore.setTopicBasedInterview(true);
  }

  const settingInterview = () => {
    const index = 0;
    const interviewItem = interviews[index];
    console.log("this is the english bot");
    // Check if the interviewItem is defined
    if (interviewItem) {
      localStorage.setItem(
        "interviewSettings",
        JSON.stringify(interviewListWithModels[index])
      );

      const index1 = interviewListWithModels.findIndex(
        (interview) => interview.id === interviewItem.id
      );

      // Check if the index1 is valid before further processing
      if (index1 !== -1) {
        console.log("this is index", index1);
        console.log("this is index", interviewListWithModels[index1]);
        InterviewStore.setInterviewSettings(interviewListWithModels[index1]);
        console.log("this is store", toJS(InterviewStore.interviewSettings));
      } else {
        console.error("Interview not found in interviewListWithModels");
      }
    } else {
      console.error("Interview not found at index", index);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
    };

    // Initial check
    handleResize();

    // Event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    // centerMode: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };
  const scrollToTop = () => {
    // scroll to top by id
    try {
      const element = document.getElementById("mobile-header");
      element.scrollIntoView({ behavior: "instant" });
    } catch (error) {}
  };
  const carouselList = [
    {
      title: "Update your #profile",
      description: "update your profile with required details",
     
      subTitle: "",
      image: careerImg1,
      action: () => {},
    },
    {
      title: "Attend #Interview",
      description: "Attend personalized mock interview",
     
      subTitle: "",
      image: careerImg2,
      action: () => {},
    },
    {
      title: "Get #Results",
      description: "Get your immediate results of interview",
     
      subTitle: "",
      image: careerImg3,
      action: () => {},
    },
    {
      title: "Get #Hired",
      description: "Get hired by recruiters immediately",
      
      subTitle: "",
      image: careerImg4,
      action: () => {},
    },
  ];

  return (
    <Slider {...settings} className="w-[95%] -my-12 md:my-0  -mx-6">
      {/* <Referral /> */}

      {carouselList.map((item, key) => (
        <Referral
          subTitle={item.subTitle}
          key={key}
          title={item.title}
          image={item.image}
          description={item.description}
          buttonText={item.buttonText}
          action={item.action}
        />
      ))}
    </Slider>
  );
}

const Referral = ({
  title,
  description,
  image,
  buttonText,
  action,
  key,
  subTitle,
}) => {
  const { UserStore, PopupStore } = useStores();

  function showReferAndEarn(onClick) {
    PopupStore.setReferAndEarn(true);
    if (onClick) {
      onClick();
    }
  }
  return (
    <Observer>
      {() => (
        <>
          
          <div
            key={key}
            className=" h-fit -my-3 md:h-[90vh] mx-auto flex -mt-6 p-3 rounded-xl background-color-[#ffd4b5] "
            // style={{
            //   background:
            //     "linear-gradient(100.96deg, #FFEFE3 44.62%, rgba(255, 212, 181, 0.96) 99.16%)",
            //   // "linear-gradient(100.96deg, #ffd4b5 44.62%, rgba(255, 212, 181, 0.96) 25.16%)",
            //   // "linear-gradient(100.96deg, #ffe8cc 44.62%, rgba(255, 232, 203, 0.96) 99.16%)",
            // }}
          >
            <div className=" lg:w-[70%] w-[80%] mx-auto md:my-2 px-5 md:py-2 flex flex-col items-center md:justify-evenly ">
              <img
                src={image}
                alt=""
                className="md:w-72 md:h-72 w-44 h-56 object-cover mx-auto md:my-auto mt-24  "
              />
              <p className="gil-med md:text-lg lg:text-3xl font-semibold text-xl opacity-100 ">
                {title.split("#").map((part, index) => {
                  if (index === 1) {
                    return (
                      <span key={index} className="text-primary">
                        {part}
                      </span>
                    );
                  }
                  return <span key={index}>{part}</span>;
                })}
              </p>
              <p className="md:text-xl lg:text-lg  text-lg opacity-60 ">
                {subTitle}
              </p>
              <p className="text-sm lg:text-lg my-2">{description}</p>

              
            </div>
          </div>
        </>
      )}
    </Observer>
  );
};
